import React from 'react';
//import PropTypes from 'prop-types';

import { createUseStyles } from '../palette';
import decorate from '../common/utils/decorate';
import HtmlView from '../common/components/HtmlView';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Button from '../ui/Button';
import Card from '../ui/Card';

const useStyles = createUseStyles((theme) => ({
  container: {
    paddingTop: theme.getFactor('card', 'indent', 2.5),
    paddingBottom: theme.get('card', 'indent'),

    position: 'relative'
  },

  close: {
    cursor: 'pointer',

    position: 'absolute',
    right: -theme.getFactor('card', 'indent', 0.5),
    top: -theme.getFactor('card', 'indent', 0.5),
    width: theme.getFactor('card', 'indent', 2),
    height: theme.getFactor('card', 'indent', 2),

    '&:before, &:after': {
      backgroundColor: theme.getColor('button', 'hint', 'contrast'),
      transition: 'color 0.2s linear, background-color 0.2s linear',

      content: '""',

      position: 'absolute',
      left: 0,
      top: '50%',
      width: theme.getFactor('card', 'indent', 2),
      height: 2
    },

    '&:hover:before, &:hover:after': {
      backgroundColor: theme.getColor('button', 'basic', 'contrast')
    },

    '&:before': {
      transform: 'rotate(45deg)'
    },

    '&:after': {
      transform: 'rotate(-45deg)'
    }
  }
}));

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;

    static decorateWith = {
      classes: useStyles
    };

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { classes, agreement, onPrevPage } = this.props;

      const { langString } = this.context;

      return (
        <Card>
          <div className={classes.container}>
            <div
              className={classes.close}
              title={langString('return')}
              onClick={onPrevPage}
            />

            <HtmlView>{langString(agreement.content)}</HtmlView>
          </div>

          <Button variant="outlined" onClick={onPrevPage}>
            {langString('return')}
          </Button>
        </Card>
      );
    }
  }
);
